import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1252242806993118';
const SCRIPT_SELECTOR = `script[data-meta-pixel-id="${PIXEL_ID}"]`;
type FacebookPixel = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: FacebookPixel;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: FacebookPixel;
  _fbq?: FacebookPixel;
  basketballResolvedPixelInitialized?: boolean;
  basketballResolvedPageViewSent?: boolean;
};
function createPixelQueue(): FacebookPixel {
  const pixel = ((...args: unknown[]) => {
    if (pixel.callMethod) {
      pixel.callMethod(...args);
      return;
    }
    pixel.queue?.push(args);
  }) as FacebookPixel;
  pixel.queue = [];
  pixel.push = pixel;
  pixel.loaded = true;
  pixel.version = '2.0';
  return pixel;
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const pixelWindow = window as PixelWindow;
    const pixel = pixelWindow.fbq ?? createPixelQueue();
    if (!pixelWindow.fbq) {
      pixelWindow.fbq = pixel;
      pixelWindow._fbq = pixel;
    }
    if (!pixelWindow.basketballResolvedPixelInitialized) {
      pixel('init', PIXEL_ID);
      pixelWindow.basketballResolvedPixelInitialized = true;
    }
    if (!document.querySelector(SCRIPT_SELECTOR)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.dataset.metaPixelId = PIXEL_ID;
      // document.head is present in browser previews; the fallbacks keep this safe
      // if the component is mounted unusually early in another environment.
      const mountPoint = document.head ?? document.body ?? document.documentElement;
      mountPoint.appendChild(script);
    }
    if (!pixelWindow.basketballResolvedPageViewSent) {
      pixel('track', 'PageView');
      pixelWindow.basketballResolvedPageViewSent = true;
    }
  }, []);
  return <noscript data-id="element-121">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-122" />
    </noscript>;
}